import { common_axios } from "../App";

export const saveMaintenance = async (payload) => {
  try {
    const res = await common_axios.post(
      "/maintainence/v1/save-maintenance-details",
      payload
    );
    return res;
  } catch (e) {}
};

export const getMaintenanceTypes1 = async () => {
  try {
    const res = await common_axios.get("/maintainence/v1/get-type");
    return res;
  } catch (e) {}
};

export const viewMaintenance = async (payload) => {
  try {
    console.log(payload);
    const res = await common_axios.post(
      "/maintainence/v1/get-maintenance-details",
      payload
    );
    console.log(res);
    return res;
  } catch (e) {}
};

export const vehicleListVendorsList = async (payload) => {
  try {
    console.log(payload);
    const res = await common_axios.post(
      "/maintainence/v1/get/vehicle-details",
      payload
    );
    console.log(res);
    return res;
  } catch (e) {}
};

export const updateMaintenance = async (payload) => {
  try {
    console.log(payload);
    const res = await common_axios.post(
      "/maintainence/v1/update-maintenance-details",
      payload
    );
    console.log(res);
    return res;
  } catch (e) {}
};
